import {GetterTree} from "vuex";
import {PurchaseOrderData} from "@/types";
import {PurchaseOrderState, RootState} from "@/types/store/adminzone";

export const getters: GetterTree<PurchaseOrderState, RootState> = {
  GET_PURCHASE_ORDER_NUMBERS: (state): Array<PurchaseOrderData> => [...state.purchaseOrderNumbers].sort((po1, po2) => po2.validTo - po1.validTo),
  GET_PURCHASE_ORDER_TOTAL_COUNT: (state) => state.purchaseOrderNumbersTotalCount
}
